import React, { PureComponent } from 'react';
import shortid from 'short-id';
import { ToastContainer } from 'react-toastify';
import { Tab, Menu, Button, Icon, Rail } from 'semantic-ui-react';
import ComparerTab from './ComparerTab';
import TabTotals from './TabTotals';

class TabContainerComponent extends PureComponent {
  componentDidMount() {
    document
      .querySelector('.App-content')
      .addEventListener('scroll', this.toggleScrollButton);
  }
  componentWillUnmount() {
    window.removeEventListener('scroll', this.toggleScrollButton);
  }
  renderMenuItemTab = (campaignKey) => (
    <Menu.Item key={campaignKey.tabKey}>
      {campaignKey.menuItem}
      <TabTotals
        className="qc-process left"
        campaignKey={campaignKey.tabKey}
        keySection="First"
      />
      <TabTotals
        className="qc-process right"
        campaignKey={campaignKey.tabKey}
        keySection="Second"
      />
    </Menu.Item>
  );

  toggleScrollButton = () => {
    try {
      if (document.querySelector('.sticky-button')) {
        if (document.querySelector('.App-content').scrollTop > 50) {
          document
            .querySelector('.sticky-button')
            .classList.remove('sticky-button-hidden');
          document
            .querySelector('.sticky-button')
            .classList.add('sticky-button-show');
        } else {
          document
            .querySelector('.sticky-button')
            .classList.remove('sticky-button-show');
          document
            .querySelector('.sticky-button')
            .classList.add('sticky-button-hidden');
        }
      }
    } catch (error) {
      console.log('Error toggleScrollButton(): ', error);
    }
  };

  scrollToTop = () => {
    document
      .querySelector('.App-content')
      .scrollTo({ top: 0, left: 0, behavior: 'smooth' });
  };

  render() {
    const {
      tabs,
      getFbToken,
      flipping,
      utms,
      adAccountName,
      sorting,
      activeIndex,
      handleTabChange
    } = this.props;
    const tabsItems = tabs.map((tab) => ({
      menuItem: this.renderMenuItemTab(tab),
      pane: (
        <Tab.Pane key={shortid.generate()}>
          <ComparerTab
            key={shortid.generate()}
            tabName={tab.tabKey}
            firstAds={tab.ads.sortedAdsFirst}
            secondAds={tab.ads.sortedAdsSecond}
            diffFirstAds={tab.ads.differentAdsFirst}
            diffSecondAds={tab.ads.differentAdsSecond}
            getFbToken={getFbToken}
            flipping={flipping}
            utms={utms}
            adAccountName={adAccountName}
            sorting={sorting}
          />
        </Tab.Pane>
      ),
      campaignKey: tab.tabKey
    }));

    return (
      <div>
        <ToastContainer />
        <div>
          <Tab
            renderActiveOnly={false}
            panes={tabsItems}
            defaultActiveIndex={activeIndex}
            onTabChange={handleTabChange}
          />
          <Rail position="right">
            <div className="sticky-button sticky-button-hidden">
              <Button color="blue" size="small" onClick={this.scrollToTop}>
                <Icon name="arrow alternate circle up" />
              </Button>
            </div>
          </Rail>
        </div>
      </div>
    );
  }
}

export default TabContainerComponent;



// WEBPACK FOOTER //
// ./src/screens/Flipper/ParentSection/TabContainerComponent.js